// Road map / history page data.
//
// Numbers, years and contact details are the source of truth for the page and
// come from the institution's posters — never generate or extrapolate values
// here. All visible wording lives in the `roadmap` i18n namespace
// (public/locales/{lng}/roadmap.json); this file only holds structure.

export const institution = {
  name: "مؤسسة دار محمد عطاوي",
  socialName: "DarMhamedAttaoui",
  facebookUrl: "https://www.facebook.com/darMhamedAttaoui",
  phoneDisplay: "+212 6 58 15 24 86",
  phoneHref: "tel:+212658152486",
  address: "J3 CYM RABAT 10130",
  mapUrl:
    "https://www.google.com/maps/search/?api=1&query=J3+CYM+Rabat+10130",
};

export const history = {
  startYear: 2018,
  endYear: 2026,
};

// One entry per academic year. `id` drives the anchor (#year-2018) and the
// optional description key `milestones.<id>.description` in the i18n file.
// Leave `students` / `teachers` undefined when the poster gives no figure —
// the card then shows only what is known.
export const milestones = [
  {
    id: "2018",
    yearHijri: "1440",
    yearGregorian: "2018-2019",
    students: 148,
    teachers: 4,
  },
  {
    id: "2019",
    yearHijri: "1441",
    yearGregorian: "2019-2020",
    students: 160,
    teachers: 6,
  },
  {
    id: "2020",
    yearHijri: "1442",
    yearGregorian: "2020-2021",
    remote: true,
  },
  {
    id: "2021",
    yearHijri: "1443",
    yearGregorian: "2021-2022",
    students: 180,
    teachers: 8,
  },
  {
    id: "2022",
    yearHijri: "1444",
    yearGregorian: "2022-2023",
    students: 206,
    teachers: 9,
  },
  {
    id: "2023",
    yearHijri: "1445",
    yearGregorian: "2023-2024",
    students: 262,
    teachers: 10,
  },
  {
    id: "2024",
    yearHijri: "1446",
    yearGregorian: "2024-2025",
    students: 272,
    teachers: 10,
  },
  {
    id: "2025",
    yearHijri: "1447",
    yearGregorian: "2025-2026",
    students: 300,
    teachers: 10,
    current: true,
  },
];

// Photo metadata overrides, keyed by file name in src/images/road-map.
// Everything is optional: `year` prints under the polaroid, `altKey` points at
// `photos.<key>` in the i18n file, `featured` enlarges the photo (used for the
// founder's portrait) and `captionKey` adds a line under it.
//
// TODO(content): fill in the founder portrait and the per-year photos once the
// institution confirms which file is which. Until then the gallery renders the
// photos with the generic alt text and no year caption.
export const photoOverrides = {
  // "founder.jpg": { featured: true, altKey: "founder", captionKey: "founder" },
  // "2018-01.jpg": { year: "2018", altKey: "students2018" },
};

// Number of photos shown before the "show more" button.
export const PHOTOS_BEFORE_FOLD = 12;

const roadMap = {
  institution,
  history,
  milestones,
  photoOverrides,
};

export default roadMap;
